import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import StorageAbstractFactory from '@infrastructure/cache';

const translator = {
  translate: key => key,
  changeLanguage: key => {},
};

const parse = key => {
  if (typeof key !== 'string') return 'InvalidTranslationKeyGiven';
  return _.startCase(key).replace(/ /g, '');
};

export function Translator({ children }) {
  const { i18n, t } = useTranslation();
  translator.translate = key => t(parse(key));
  translator.changeLanguage = key => {
    if (['es', 'en', 'ca'].includes(key)) {
      i18n.changeLanguage(key);
      StorageAbstractFactory.getSyncGlobalInstance().setItem('i18nextLng', key);
    }
  };
  return <>{children(translator)}</>;
}

export function withTranslator(Component) {
  return function (props) {
    return <Component {...props} translator={translator} />;
  };
}

export default translator;
